// Runs (deferred) immediately after jquery-3.7.1.min.js on collection pages.
//
// Timesact checks `parseFloat(jQuery.fn.jquery) < 100.0` to decide whether to load its own
// copy of jQuery. Real versions (3.7.1 -> 3.7) are always < 100, so we report a fake version
// to prevent a duplicate load. This used to be an inline script that ran right after a
// synchronous jQuery tag; with jQuery deferred it has to run after jQuery executes.
// The filename contains "jquery" so it matches the /jquery/ Yett allowlist entry.
if (window.jQuery) {
  window.jQuery.fn.jquery = "100.0";
}
